<template>
  <div class="news">
    <div class="boxCenter">
      <div class="insideBanner">
        <img :src="bannerImg" alt="TINDOE坦途"/>
        <!--<div class="title">新闻公告</div>-->
      </div>
      <div class="newsList">
        <ul>
          <li v-for="(item,index) in newList" :key="index">
            <router-link :to="'/newsDetails/'+item.id">
              <div class="imgBox"><img :src="item.pic" alt="TINDOE坦途"/></div>
              <div class="info">
                <div class="title">{{item.title}}</div>
                <div class="time">{{item.createDate?item.createDate.substring(0,19):''}}</div>
                <div class="des">{{item.digest}}</div>
                <div class="checkInfo"><a>查看详情</a></div>
              </div>
            </router-link>
          </li>
        </ul>
        <div style="padding:100px;text-align: center">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page="curPage"
            :page-size="10"
            :total="totalNews">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        newList:[],
        curPage:1,
        totalNews:0,
        bannerImg:''
      }
    },
    mounted(){
      this.loadNewList()
      this.loadBanner()
    },
    methods:{
      loadBanner(){
        this.$https.get('/api/config').then((response)=>{
          this.dataObj = response.data
          for(let i=0;i<response.data.length;i++){
            let item = response.data[i]
            if(item.id == 10){
              this.bannerImg = item.msg
              break
            }
          }
        }).catch((error) => {

        });
      },
      handleCurrentChange(val){
        this.curPage = val
        this.loadNewList()
      },
      loadNewList(){
        this.$https.get('/api/news/pageIndex/'+this.curPage+'/pageNum/10').then((response)=>{
          this.newList = response.data.records
          this.totalNews = response.data.total
        });
      }
    }
  }
</script>

<style scoped>
  .news{
    background:#fafafa;
  }
  .insideBanner{
    width: 1200px;
    height: 275px;
    position: relative;
  }
  .insideBanner .title{
    font-size: 48px;
    color: #ffffff;
    width: 100%;
    text-align: center;
    left: 0px;
    top: 80px;
    position: absolute;
  }

  .newsList{
    padding-top: 36px;
    min-height: 1000px;
  }
  .newsList li{
    padding: 27px 33px;
    overflow: hidden;
  }
  .newsList li:hover{
    background: #f0f0f0;
  }
  .newsList .imgBox{
    float: left;
    width: 248px;
    height: 165px;
  }
  .newsList .imgBox img{
    width: 100%;
    height: 100%;
  }
  .newsList .info{
    float: left;
    width: 860px;
    margin-left: 20px;
  }
  .newsList .info .title{
    padding-top: 5px;
    height: 33px;
    line-height: 33px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size: 18px;
    color: #5680f9;
  }
  .newsList .info .time{
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    color: #969696;
  }
  .newsList .info .des{
    padding-top: 2px;
    max-height: 46px;
    line-height: 23px;
    overflow: hidden;
    font-size: 14px;
    color: #646464;
  }
  .newsList .info .checkInfo{

  }
  .newsList .info .checkInfo a{
    display: block;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: #5680f9;
    color: #ffffff;
    font-size: 15px;
    margin-top: 23px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue